import { createContext, Dispatch, FC, PropsWithChildren, useCallback, useMemo, useState } from 'react'
import { IntlProvider } from 'react-intl'

import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/uk'

import en from '../resources/intl/messages.en.json'
import uk from '../resources/intl/messages.uk.json'

type Locale = 'uk' | 'en'
const translations: Record<Locale, { key: string; value: string }[]> = {
  uk: uk.data.translations,
  en: en.data.translations,
}

const DEFAULT_LOCALE: Locale = 'uk' as const

type ContextProps = { locale: Locale; setLocale: Dispatch<Locale> }

const initialState: ContextProps = {
  locale: DEFAULT_LOCALE,
  setLocale: () => null,
}

const Context = createContext(initialState)

const initialLocale: Locale = (localStorage.getItem('locale') as Locale) ?? initialState.locale
dayjs.locale(localStorage.getItem('locale') ?? 'uk')

const Intl: FC<PropsWithChildren> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>(initialLocale)
  dayjs.locale(locale)

  const switchLocale: Dispatch<Locale> = useCallback((value: Locale) => {
    localStorage.setItem('locale', value)
    setLocale(value)
  }, [])

  // const { data, loading } = useTranslationsQuery({ variables: { locale } })

  const messages = useMemo(
    () =>
      translations[locale]
        // data?.translations
        ?.map((it) => ({ [`${it?.key}`]: `${it?.value}` }))
        ?.reduce((each, all) => ({ ...each, ...all }), {}),
    // [data?.translations],
    [locale],
  )

  return (
    <Context.Provider value={{ locale, setLocale: switchLocale }}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { Intl, Context, type Locale }
